import { render, staticRenderFns } from "./ad-edit-bidStrategy.vue?vue&type=template&id=511131f6&scoped=true&"
import script from "./ad-edit-bidStrategy.vue?vue&type=script&lang=js&"
export * from "./ad-edit-bidStrategy.vue?vue&type=script&lang=js&"
import style0 from "./ad-edit-bidStrategy.vue?vue&type=style&index=0&id=511131f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511131f6",
  null
  
)

export default component.exports